import React from 'react';
import '../template-file-css/document-file-template.css';



export const BTCS_DischargeSummary = ({
    itemsRef,
    showErrorFor,
    
}) => {

    return (
        <form id='BTCS_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>

            <p className='w-750'><h3><center>Discharge Summary</center></h3></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Birth:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClientName_1' name='txtClientName_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDateofBirth_2' name='txtDateofBirth_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Therapist:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Case Manager:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTherapist_3' name='txtTherapist_3' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtCaseManager_4' name='txtCaseManager_4' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAddress_5' name='txtAddress_5' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Email:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_6' name='txtPhone_6' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtEmail_7' name='txtEmail_7' className='add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of admission:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of last service:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of discharge:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtDateOfAdmission_8' name='txtDateOf_8' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtDateOfLastService_9' name='txtDateOfLastService_9' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtDateofDischarge_10' name='txtDateofDischarge_10' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Discharge Request:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbDischargeRequest_Agency' name='rbDischargeRequest' className='add-only' value='Agency' /> Agency</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDischargeRequest_Service' name='rbDischargeRequest' className='add-only' value='ServiceOnly' /> Service Only:</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDischargeRequest_Cpst' name='rbDischargeRequest' className='add-only' value='CPST' /> CPST </td>
                        <td className='w-187'>
                            <input type='radio' id='rbDischargeRequest_Psychotherapy' name='rbDischargeRequest' className='add-only' value='Psychotherapy' /> Psychotherapy</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Discharge Type:</span>
                    <input type='radio' id='rbDischargeType_Planned' name='rbDischargeType' className='add-only' value='Planned' /> Planned &nbsp;
                    <input type='radio' id='rbDischargeType_NotPlanned' name='rbDischargeType' className='add-only' value='Not Planned' /> Not Planned
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Discharge Initiated by:</span>
                    <input type='radio' id='rbDischargeInitiated_Client' name='rbDischargeInitiated' className='add-only' value='Client' /> Client &nbsp;
                    <input type='radio' id='rbDischargeInitiated_Agency' name='rbDischargeInitiated' className='add-only' value='Agency' /> Agency
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Discharge (Specify):</span>
                            <select id='ddlDischargeSpecify' name='ddlDischargeSpecify' className='add-only'>
                                <option value='PleaseSelectDischargeReason'>Please Select Discharge Reason</option>
                                <option value='ClientRejectsRefusesServices'>Client rejects/refuses services</option>
                                <option value='ClientNonCompliant'>Client non-compliant</option>
                                <option value='ClientDied'>Client died</option>
                                <option value='ClientIncarcerated'>Client incarcerated</option>
                                <option value='Clientmoved'>Client moved</option>
                                <option value='ClientNeedsServicesNotProvidedBy'>Client needs services not provided by BTCS</option>
                                <option value='InsuranceLapsedInactive'>Insurance lapsed/inactive</option>
                                <option value='GoalsMet'>Client moved</option>
                                <option value='OtherPleaseExplainBelow'>Other (please explain below)</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtDateofDischarge_11' name='txtDateofDischarge_11' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Client notified the right to appeal:</span>
                    <input type='radio' id='rbClientNotifiedTheRight_Yes' name='rbClientNotifiedTheRight' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientNotifiedTheRight_No' name='rbClientNotifiedTheRight' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Medications:</span>
                    <textarea id='txtMedication' name='txtMedication' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Summary of Service:</span>
                    <textarea id='txtSummaryOfService' name='txtSummaryOfService' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Outcome of Service:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbOutComeOfService_Successful' name='rbOutComeOfService' className='add-only' value='Agency' /> Successful</td>
                        <td className='w-187'>
                            <input type='radio' id='rbOutComeOfService_Neutral' name='rbOutComeOfService' className='add-only' value='ServiceOnly' /> Neutral</td>
                        <td className='w-187'>
                            <input type='radio' id='rbOutComeOfService_Unsuccessful' name='rbOutComeOfService' className='add-only' value='CPST' /> Unsuccessful</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Recommendations and transition plan:</span>
                    <span className='small'>A letter will be provided to the client regarding discharge, the option to return for services at a later time, and information for additional supports to address their Mental Health concerns.</span>
                    <textarea id='txtRecommendationAndTransition' name='txtRecommendationAndTransition' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp;</td>
                        <td className='signature w-300'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-300'> Clinician (Print Name):</td>
                        <td className='small w-300'> Clinician (Signature):</td>
                        <td className='small w-150'> Date</td>
                    </tr>
                </table>

            


            </div>
        </form>

    )
}  
